var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAlignCenterIcon = function SvgAlignCenterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h36v34H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "#545454"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.25 18h9.5v7.5h-9.5V18zm-4-10.5h17.5V15H9.25V7.5z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.75 18v7.5h-9.5V18h9.5zm4-10.5V15H9.25V7.5h17.5zm-5.5 12h-6.5V24h6.5v-4.5zm4-10.5h-14.5v4.5h14.5V9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 25.5V28h-2v-2.5h2zM19 15v3h-2v-3h2zm0-10v2.5h-2V5h2z",
    opacity: 0.65
  })))));
};

export default SvgAlignCenterIcon;